export default "__VITE_ASSET__BvuluGjB__"